<template>
  <path
    d="M16.2427 6.34317L14.8285 4.92896L7.75737 12L14.8284 19.0711L16.2426 17.6569L10.5858 12L16.2427 6.34317Z"
  />
</template>
